import React, { Suspense, Component } from "react";
import {
  withRouter
} from 'react-router-dom';
import {
  // Modal, List, Text, 
  Icon,
  Modal
} from "@shopify/polaris";
import './index.css'
import {
  BehaviorMajor,
} from '@shopify/polaris-icons';

import {
  reqAddActionEventLog,
  reqGetHomeCommonData,
  // reqGetDiscountAct,
  reqGetAppAds,
  reqDelCache,

} from '../../../api';
//新人折扣弹窗
import EventInformation from '../DashboardV2/components/EventInformation/index'
import ToastFunc from "../../../components/ToastFunc";
import SkeltonLoading from "../../../components/SkeltonLoading";
import utils from '../../../utils/utils';
import 'swiper/css'; // 公共引入轮播图样式
import 'swiper/css/bundle'; // 公共引入轮播图样式

// 获取全局公共数据
import { connect } from 'react-redux'
import { setPublicData, changeActShowStatus, setWindowWidth, setWindowScrollY, setAppPublicInit, setGuideModalStatus, setPayTipStatus, setActMealResData, setTopMenuState, setAllAdverData, setScrollHiddenState, savePayTip, setShopifyLang, changeLanguageInfo, setLangState, setSaveSwitchData, setWindowSendData } from '../../../redux/actions/getAppPublicData';
import { store } from '../../../redux/store'

// loading
import SkeltonSpinnerLoading from '../../../components/SkeltonSpinnerLoading';
import Language from '../../../i18n/Language';

// 入口页面
import SpeedOptimization from '../SpeedOptimization/indexClass';
import SearchAppearance from '../SearchAppearance/indexClass';
import Backlinks from '../Backlinks/indexClass';
import SeoAnalytics from '../SeoAnalytics/indexClass';
import ReportData from '../ReportData/indexClass';

// 关键词合并页面
import KeywordsResearch from '../KeywordsResearch/indexClass';

//首页
import DashboardClass from '../DashboardV2/dashboardClassNewV3';
//分数检测服务页面
import SiteSpeedup from '../SiteSpeedup/indexClass';

import ManualBulkEdit from '../BulkEditTag/indexClass';
//图片压缩页面V2
import ImageOptimization from '../PageSpeed/indexV2/indexClass';
import ImageOptimizationDetail from '../PageSpeed/indexV2/detail/indexClass';
import ImageOptimizationSettings from '../PageSpeed/indexV2/setting/ImageSettings';
import ImageAltText from '../ImageAltText/index';
import ImageOptAltDetail from '../ImageAltText/historyTable/detail/indexClass';

//404 broken link 页面
import BrokenLinkPage from '../BrokenLink/indexClass';
//HTML Sitemap 页面
import HtmlSitemap from '../HtmlStiemap/index/indexClass';
// Json LD 页面
import StructuredData from '../SnippetsJSONLD/index/JsonLdIndexV3';
// 关键词
import KeywordsData from '../Keywords/indexClass';
//竞品关键词分析页面
import CompetitorKeywordsDetail from '../CompetitorKeywordsDetail/indexClass';
//价格页面
import Pricing from '../Pricing/index/Pricing';
import OldPricing from '../Pricing/oldversion/Pricing';
//问答页面
import Canny from '../Canny/indexClass';
//推荐应用页面
import Integration from '../Integration/indexClass';
// Instant Page
import InstantPage from '../InstantPage/indexClass';
// 及时索引
import InstantIndex from '../InstantIndex/indexClass';
// local-business
import LocalBusiness from '../LocalBusiness/indexClass';
// 设置页面
import Settings from '../Settings/indexClass';
// 新手引导
import NewUserGuide from "../NewUserGuide";
import TaskReward from "../../../components/TaskReward/indexV2";
import UpgradeModal from "../../../components/UpgradeModal";
// shopify api组件
import NavMenuList from "../../../components/NavMenuList";
import ModalAMPCustomize from "../../../components/ModalElement/ModalAMPCustomize";
import ModalOnpageAI from "../../../components/ModalElement/ModalOnpageAI";
import ModalOnpageBlog from "../../../components/ModalElement/ModalOnpageBlog";
import CongratsModal from "../../../components/CongratsModal";
import { cloneDeep, debounce } from "lodash";
import NewReviewModal from "../../../components/ReviewModal";

// ****** 设置懒加载页面
// 最近改进 页面
const RecentImprove = React.lazy(() => import('../DashboardV2/components/SavingTimeReport/indexV2'));
//SEO Checker 检测页面
const WebsiteCheckClass = React.lazy(() => import('../WebsiteCheck/indexClass'));
//On page 操作页面
const OnPageSEOIndexClass = React.lazy(() => import('../OnPageSEO/index/indexClassV2'));
// onpage 详情页
const OnPageSEODetail = React.lazy(() => import('../OnPageSEO/index/components/SheetDetail/index'));
// 创建博客
const CreateBlogContent = React.lazy(() => import('../OnPageSEO/index/components/CreateBlogContent/index'));
//外链互换页面
const ExchangeBacklink = React.lazy(() => import('../ExchangeBacklink/indexClass'));
const BacklinkAudit = React.lazy(() => import('../BacklinkAudit/indexClass'));
//AMP 页面
const ServiceAMPClass = React.lazy(() => import('../ServiceAMP/indexClass'));
const ServiceAMPCustome = React.lazy(() => import('../ServiceAMP/custome/indexClass'));
//google流量分析页面
const GoogleSearchConsole = React.lazy(() => import('../AdvancedSettings/GoogleSearchConsoleV2/indexClassV2'));
// 关键词搜索
const KeywordsSearch = React.lazy(() => import('../KeywordsSearch/indexClass'));
// 关键词对比
const KeywordsGap = React.lazy(() => import('../KeywordsGap/indexClass'));
// 竞争网站对比
const KeywordsMonitor = React.lazy(() => import('../KeywordsMonitor/indexClass'));
// 我的网站关键词
const KeywordsWebsite = React.lazy(() => import('../KeywordsWebsite/indexClass'));
// 关键词列表
const KeywordsList = React.lazy(() => import('../KeywordsList/indexClass'));

const t = Language;
let cacheTimer = [];
// let indexTag = 0;

class FrameClass extends Component {
  state = {
    //升级框
    proPlanshow: false,
    //高级版升级弹窗
    premiumPlanShow: false,
    //选择页面
    pageName: this.props.name,

    shopOwer: 'Admin',
    shopOwerNamePrefix: 'A',
    isAuthToAliExpress: false,
    aliExpressUserNick: '',
    authAliExpressModalActive: false,

    mobileNavigationActive: false,
    showClean: false,
    cleanCodeLoading: false,
    //弹窗
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误
    app_status: 1,
    has_selected: false,
    selected_404: '',
    selected_json: '',
    selected_all: '',
    recover_404: '',
    recover_json: '',
    recover_all: '',
    clean_all_picture: '', //all 图片
    //等级
    level: 0,
    //语言
    selectedLanguage: window.language ? window.language : 'en',
    shopify_level: '',

    showCleanPrompt: false,

    //是否显示好评弹窗
    showReview: false,
    //点击打开好评弹窗
    openReview: false,
    //好评弹窗文字
    reviewContent: '',

    //弹窗评价name和邮箱
    modalName: '',
    modalEmail: '',
    modalDefaultEmail: '',

    //用户服务开关
    userServices: {},

    newList: [],
    loadingShowNewsOpen: true,

    countNews: 0,

    staff: [
      'Abbey Mayert',
      'Abbi Senger',
      'Abdul Goodwin',
      'Abdullah Borer',
      'Abe Nader',
      'Abigayle Smith',
      'Abner Torphy',
      'Abraham Towne',
      'Abraham Vik',
      'Ada Fisher',
      'Adah Pouros',
      'Adam Waelchi',
      'Adan Zemlak',
      'Addie Wehner',
      'Addison Wexler',
      'Alex Hernandez',
    ],
    visibleStaffIndex: 5,

    languageActive: false,

    LanguageSelectArr: {
      'en': window.language === 'en' ? true : false,
      'fr': window.language === 'fr' ? true : false,
      'ge': window.language === 'ge' ? true : false,
      'it': window.language === 'it' ? true : false,
      'pt': window.language === 'pt' ? true : false,
      'sp': window.language === 'sp' ? true : false,
      'dut': window.language === 'dut' ? true : false,
      'in': window.language === 'in' ? true : false,
      'zh': window.language === 'zh' ? true : false
    },

    //通知功能
    messageStatus: true,
    messageSelected: 0,
    messagePage: 1,
    messageHasMore: true,
    typeTabs: [
      {
        id: 3,
        content: t("Expert service"),
        accessibilityLabel: "All customers",
        panelID: "expert-message-id"
      }, {
        id: 2,
        content: t("Paid Plan"),
        panelID: "paid-message-id"
      }, {
        id: 1,
        content: t("System"),
        panelID: "sys-message-id"
      }],

    messageTotal: {},
    messageUnreadTotal: {},
    firstGetStauts: true,

    couponExpirationString: " ",
    couponExpirationTimer: 0,

    // 导航栏子项选中
    topNavSelectArr: {
      '/searchAppearance/bulk-edit/manual-bulk-edit': window.location.pathname === '/searchAppearance/bulk-edit/manual-bulk-edit' ? true : false,
      '/speedOpt/PageSpeed': window.location.pathname === '/speedOpt/PageSpeed' ? true : false,
      '/admin/PageSpeed/setting': window.location.pathname === '/admin/PageSpeed/setting' ? true : false,
      '/on-page-seo': window.location.pathname === '/on-page-seo' ? true : false,
      '/backlinks/broken-link/view-errors': window.location.pathname === '/backlinks/broken-link/view-errors' ? true : false,
      '/backlinks/broken-link/manage-redirects': window.location.pathname === '/backlinks/broken-link/manage-redirects' ? true : false,
      '/backlinks/broken-link/ignore-page': window.location.pathname === '/backlinks/broken-link/ignore-page' ? true : false,
      '/backlinks/html-sitemap': window.location.pathname === '/backlinks/html-sitemap' ? true : false,
      '/backlinks/exchange-backlink': window.location.pathname === '/backlinks/exchange-backlink' ? true : false,
      '/searchAppearance/GoogleSearchConsoleV2': window.location.pathname === '/searchAppearance/GoogleSearchConsoleV2' ? true : false,
      '/searchAppearance/structured-data': window.location.pathname === '/searchAppearance/structured-data' ? true : false,
      '/admin/Competitor-Keywords': window.location.pathname === '/admin/Competitor-Keywords' ? true : false,
      '/keywordRearch/keywords-research/Competitor-keywords-detail': window.location.pathname === '/keywordRearch/keywords-research/Competitor-keywords-detail' ? true : false,
      '/admin/Keywords-Library': window.location.pathname === '/admin/Keywords-Library' ? true : false,
      '/speedOpt/seo-ant-amp': window.location.pathname === '/speedOpt/seo-ant-amp' ? true : false,
      '/admin/function-integration': window.location.pathname === '/admin/function-integration' ? true : false,
    },

    // 顶部导航栏
    tabs: [

    ],
    topSelected: window.topNavSelected ? window.topNavSelected : 0,
    // 顶部导航栏第一个下拉
    basicActive: false,
    AdvancedActive: false,
    // 顶部导航栏url
    topUrl: '',
    //监听屏幕
    wInnerWidth: window.innerWidth,

    //新手引导遮罩状态
    noviceGuideBackdropStatus: false,
    //新手引导气泡状态
    noviceGuideBubbleStatus: true,
    //是否首次打开新手引导
    isFirstShownoviceGuide: false,
    //是否展示hi模块
    showHi: false,
    //优惠券数据
    showCouponData: false,
    //除了首页和价格页 其他页面传空 新人折扣弹窗
    showType: window.location.pathname === '/dashboard' ? 'index' : (window.location.pathname === '/plan' ? 'pricing' : ''),
    //是否点击了右侧礼物盒 修改新人折扣弹窗状态
    openStatus: false,
    //是否第一次关闭 优惠弹窗 false 没有点击 true 点击
    isFirstCloseConponModal: false,
    //新手引导是否结束
    noviceGuideIsDone: false,
    //第一次请求关闭弹窗接口
    firstReqClose: false,
    // 活动展示状态
    showBlackFridayModal: -1,
    showBlackFridayBanner: -1,
    curPage: window.location.pathname,
    //弹窗组件传来的时间
    fromModalTime: "00:00:00",

    // 活动数据
    isHasActivity: false, // 是否有活动
    activityMes: {},
    actId: -1, // 活动id
    actName: '', // 活动Name

    isResetData: false, // 是否第二次以上更新

    isExpandedNav: true, // 是否展开左侧导航栏
    ishoverExpandeNav: false, // 是否触摸展开导航栏
    isShowNavIcon: false, // 是否展示菜单new||hot图标
    isHideNewbieTipModal: null, // 新手引导提示弹窗第二状态
    isShowRouteBlock: false,
    isHasActivityMeal: false, // 改版活动状态
    ActRversion: {}, // 改版活动数据
    act_expired_time: '00:00:00', // 倒计时
    act_expired_mills_time: '00', // 毫秒
    openActMealModal: false,
    isShowInfo: false,   // 是否展示
    uid: -1,
    adverInfo: {}, // 广告数据
    adverloading: true,
    isShowTask: false,
    isNewUserIncentives: false, // 是否存在任务
    switchData: {},
    quotaAll: {},
    isAddImageQuota: false, // 增加图片额度
    upgradeModalShow: false,  // 价格弹窗状态
    isActLoading: true,
    trial_days: 0,          // 剩余试用天数
    creditsShow: false,     // 是否提示ai积分
    isShowExpertModal: false,       // 专家服务弹窗
    ppid: -1,   // 版本id
    isShowShopifyNavMenu: true,  // 内嵌侧边栏
    isCanSetModal: false,        // 是否支持打开模态框
    isHideNav: false,   // 是否隐藏侧边栏
    onpagePubilsh: true,  // 内部是否发布
    onpagePubilshLoading: false,

    // 内嵌事件对象
    embedOnpageAIData: null,
    congraState: false,   // 新手引导完成状态

    journeyList: {
      "EmBed": {
        "id": 4,
        "title": "EmBed",
        "tag": "Enable app embed",
        "desc": "Some important functions require the seoant extension to be installed before they can be used.",
        "btn": "Enable app embed",
        "url": "",
        "status": false,
        "img": "/ai/PointSaleChannel.png"
      },
      "OptimizeImages": {
        "id": 1,
        "title": "Optimize images",
        "tag": "Optimize images",
        "desc": "By optimizing to reduce the file size of your images without sacrificing image quality, you can make your pages load faster!",
        "btn": "Optimize Now",
        "url": "/speedOpt/PageSpeed",
        "status": false,
        "img": "/ai/ImageToCompress.png"
      },
      "SiteSpeedUp": {
        "id": 2,
        "title": "Speed up your store",
        "tag": "Speed up your store",
        "desc": "Helps your website load faster with just one click",
        "btn": "Speed up now",
        "url": "/speedOpt/site-speedup",
        "status": false,
        "img": "/ai/WebsitPageSpeedUp.png"
      },
      "On-pageSEO": {
        "id": 3,
        "title": "Using AI to optimize On-page SEO",
        "tag": "Using AI to optimize On-page SEO",
        "desc": "Scan and analyze on-page elements with AI writer to ensure they follow Google's recommended practices for optimal results.",
        "btn": "Optimize Now",
        "url": "/on-page-seo",
        "status": false,
        "img": "/ai/UseAiOpt.png"
      },
      "MetaTags": {
        "id": 5,
        "title": "Learn bulk edit Meta Tags",
        "tag": "Learn bulk edit Meta Tags",
        "desc": "Bulk edit meta tags to make it easier for search engines to find your pages.",
        "btn": "Set Meta Tags rules",
        "url": "/searchAppearance/bulk-edit/manual-bulk-edit",
        "status": false,
        "img": "/ai/SetMetaTagsImg.png"
      },
    },

    isDouble: false,   // uid -- 双数true 单数false
    embedOnpageBlogData: null, // ai博客数据
    isFromPage: "",
    isShowFeedback: false,      // 任务问题列表弹层状态
    isShowSharePlat: false,     // 任务分享平台弹层状态
    isNeedCio: true, // 是否需要上传cio

    //点击打开好评弹窗
    openReview: false,
    //好评弹窗文字
    reviewContent: '',
    //弹窗评价name和邮箱
    modalName: '',
    modalEmail: '',
    modalDefaultEmail: '',

  }

  UNSAFE_componentWillMount() {
    // 动态删除之前插入的样式，恢复滚动条 (在设置页的cw集合页)
    if (this.props.public.isHiddenScroll) {
      const styleTags = document.head.getElementsByTagName('style');
      for (let i = 0; i < styleTags.length; i++) {
        if (styleTags[i].innerHTML.includes('.isSetScrollHidden{}')) {
          document.head.removeChild(styleTags[i]);
        }
      }
      this.props.setScrollHidden(false);
    }
  }

  //进入页面调用接口
  componentDidMount() {
    // 增加内嵌模式判断 - 翻译
    const isShopify = window.shopify;
    if (isShopify) {
      // 全屏 窗口通信
      if (window.opener) {
        window.addEventListener('message', this.handleDataFromMainWin); // 接收主窗口数据
      } else {
        window.addEventListener('message', this.handleDataFromChildWin); // 接收子窗口数据
      }
    }

    const storeStatus = store.getState().public.status;   // cw埋点状态

    // 访问方式
    this.props.setShowTopMenu(Boolean(!isShopify));
    const _store = this.props.public;
    const _query = Boolean(this.props.history.location?.query === 'guide');
    this.setState({
      isDouble: _store.uid % 2 === 0,
      isNeedCio: !Boolean(storeStatus), // 是否需要上传cio
    }, () => {
      if (storeStatus) {
        this.cioDataSet();
      }

      // 调用redux派遣 根据状态只调用一次
      if (!_store.status || _query) {
        // 如果全局公共数据状态为0则请求
        this.getPublicAppData();
      } else {
        let switchData = store.getState().public.publicInit.head_data?.switch_data;
        let isGoGuide = typeof switchData === 'boolean' ? true : (Boolean(switchData?.newbie_guide_page) ? Boolean(Number(switchData?.newbie_guide_page?.st) === 0) : false);
        let isGoPricing = typeof switchData === 'boolean' ? false : (Boolean(switchData?.select_version) ? Boolean(Number(switchData?.select_version?.st) === 0) : false);
        if (isGoGuide) {
          this.setState({
            isShowShopifyNavMenu: false
          }, () => {
            utils.routeJump(this, "/guide");
          })
        } else if (isGoPricing) {
          this.setState({
            isShowShopifyNavMenu: false
          }, () => {
            utils.routeJump(this, "/plan");
          })
        } else {
          this.setState({
            isCanSetModal: true
          })
        }

        this.props.setAppPublicInit();
        // 获取顶部数据
        this.getHeaderInfo(_store.publicInit);
        // 获取活动数据
        this.getIndexInfoData(_store.publicInit);
        // 如果是首页请求更新一次
        if (window.location.pathname === '/dashboard' || window.location.pathname === '/') {
          this.setState({
            isResetData: true,
            quotaAll: _store.publicInit.meal_data,
            switchData,
          }, () => {
            // 第二次先缓存再更新
            this.getPublicAppData();
            this.changeAppHomeStatus();
          })
        }
      }

      const url = this.props.history.location.pathname;
      if (url && (url.includes('/dashboard') || url === '/')) {
        this.getRecommandAppList(_store.AllAdverData); // 获取广告
      } else {
        this.setState({
          adverloading: false,
        })
      }

      // 获取改版活动数据
      // if(Object.keys(_store.ActMealData).length > 0) {
      //   this.getDiscountActData(_store.ActMealData)
      // } else {
      //   this.getDiscountActData(); 
      // }

      // // 获取改版活动数据
      this.getDiscountActData();

      // 切换默认在顶部开始预览
      window.scrollTo(0, 0);

      // 默认展开导航栏
      if (window.isSetNav === '') {
        window.isExpandedNav = true;
        window.isHoverChange = false;
      }

      window.FrameBlock = this; // 缓存事件
      window.addEventListener('resize', this.reSize, true);
      this.setState({
        isExpandedNav: window.isExpandedNav,
        isHoverChange: window.isHoverChange
      }, () => {
        this.resetContentSite();
        if (!isShopify) {
          this.optNavMenuIcon();
        }
      })
    })

    store.subscribe(() => {
      // 设置新手引导结果
      this.updUserGuideRes();

      // 判断数据
      const _winData = store.getState().public?.windowData;
      if (_winData) {
        this.setWindowSendData(_winData);
      }
    })
  }

  // cw埋点
  cioDataSet = () => {
    try {
      let url = window.location.pathname || '';
      if (window.shopify && window.cio?.initialized) {
        window.cio?.page({
          pathname: url.includes('/dashboard') ? '/' : url, // 当前页面路径
          triggerIO: true // 是否立即上报
        })

        // 判断首页和套餐页执行事件上传
        if (url.includes('/dashboard') || url.includes('/plan')) {
          window.cio?.trigger({
            event: url.includes('/dashboard') ? 'view_home_page' : 'view_plan_page', // 事件名称
          })
        }
      }
    } catch { }
  }

  // 设置数据
  setWindowSendData = (data) => {
    const _t = data;
    if (_t.mode === "edit_page_modal") {
      // 根据不同modal组件传参定义事件
      switch (_t.objs) {
        // case "amp":
        // break;
        case "onpageAi":
          if (_t._query) {
            this.setState({
              embedOnpageAIData: _t._query,
            })
          }
          break;
        case "onpageBlog":
          if (_t._query) {
            this.setState({
              embedOnpageBlogData: _t._query,
            })
          }
          break;
        default:
          break;
      }
    }
  }

  // 设置结果
  updUserGuideRes = () => {
    let _switch = store.getState().public.publicInit.head_data?.switch_data;
    let steps = _switch?.manual_guide;
    if (steps) {
      let journeyData = cloneDeep(this.state.journeyList);
      journeyData['EmBed']['status'] = journeyData['EmBed']['status'] ? true : Boolean(steps.seoant_core?.st);
      journeyData['EmBed']['url'] = store.getState().public.publicInit.other_options.seoant_core_url || '';
      journeyData['OptimizeImages']['status'] = steps.img_comp.st;
      journeyData['SiteSpeedUp']['status'] = steps.speed_up.st;
      journeyData['On-pageSEO']['status'] = steps.page_opt.st;
      journeyData['MetaTags']['status'] = steps.meta_tag.st;
      let isAllin = Object.values(journeyData).filter(i => !Boolean(i.status));
      this.setState({
        journeyList: journeyData,
        isShowGetQuota: (Boolean(_switch?.dashboard_imgQuota) || isAllin.length > 0) ? false : true,
        isGetGuideCoupon: typeof switchData === 'boolean' ? false : Boolean(_switch?.get_guide_coupon),
        isGetGuideEffect: typeof switchData === 'boolean' ? false : Boolean(_switch?.get_guide_coupon?.st === 1),
      }, () => {
        setTimeout(() => {
          this.setCongratsState();
        }, 3000)
      })
    }
  }

  // 设置状态
  setCongratsState = debounce(() => {
    let urlArr = [
      "/speedOpt/PageSpeed",
      "/speedOpt/PageSpeed/settings",
      "/speedOpt/site-speedup",
      "/on-page-seo",
      "/on-page-seo/detail",
      "/searchAppearance/bulk-edit/manual-bulk-edit",
    ]
    let url = window.location.pathname;
    let { isShowGetQuota, isGetGuideCoupon, isGetGuideEffect, congraState } = this.state;
    let isOperaState = false;
    try {
      isOperaState = Boolean(sessionStorage.getItem("isOperaCongrats"));
    } catch (e) { }
    this.setState({
      congraState: congraState === -1 ? false : (!isOperaState && isShowGetQuota && urlArr.includes(url) && isGetGuideCoupon && !isGetGuideEffect),
    })
  }, 500)

  resetContentSite = () => {
    if (store.getState().public.isShowTopMenu) {
      const SEOContent = document.getElementById('SEOpage_content');
      const TabsPublic = document.getElementById('TabsPublic');
      if (Boolean(window.isExpandedNav) && Boolean(!window.isHoverChange) && window.innerWidth > 768) {
        Boolean(SEOContent) && (SEOContent.style.paddingLeft = '15rem');
        Boolean(TabsPublic) && (TabsPublic.style.paddingLeft = '15rem');
      } else {
        Boolean(SEOContent) && (SEOContent.style.paddingLeft = '3.8rem');
        Boolean(TabsPublic) && (TabsPublic.style.paddingLeft = '3.8rem');
      }
    }
  }

  // 子窗口传参
  handleDataFromChildWin = (ev) => {
    const _that = ev.data;
    if (_that.mode === "UpgradeOpener") {
      this.handleModalCustomizeState(false, _that.url, _that.objs, _that._state, _that._query);
    } else if (_that.mode === "UpdatePublish") {
      this.setState({
        onpagePubilsh: Boolean(_that.data?.publish),
        onpagePubilshLoading: Boolean(_that.data?.loading),
      })
    } else { }
  }

  // 获取超管广告数据
  getRecommandAppList = async (data) => {
    let params = {
      platform: 'seoant'
    }
    let res = {};
    if (data?.ack === 1) {
      res = data;
      this.getRecommandAppList({});
    } else {
      res = await reqGetAppAds(params);
    }
    if (res.ack === 1) {
      this.props.setAdminAdverData(res);
      this.setState({
        adverInfo: res,
        adverloading: false
      })
    }
  }

  // 优化导航图表
  optNavMenuIcon = () => {
    // 部分icon高亮特殊处理
    const fillUrls = ['/on-page-seo'];
    const fillMoreUrls = ['/keywordRearch', '/keywordRearch/keywords-research', '/speedOpt/seo-ant-amp'];
    const strokeUrls = ['/website-check', '/settings'];
    const strokeMoreUrls = ['/speedOpt', '/searchAppearance', '/backlinks', '/speedOpt/site-speedup', '/searchAppearance/bulk-edit/manual-bulk-edit', '/searchAppearance', '/speedOpt', '/plan'];
    let jumpIconUrl = document.querySelectorAll('.Polaris-Navigation__Item.Polaris-Navigation__Item--selected.Polaris-Navigation--subNavigationActive');
    let jumpMoreIconUrl = document.querySelectorAll('.Polaris-Navigation__Item.Polaris-Navigation--subNavigationActive');
    // 一级导航
    jumpIconUrl.forEach(objs => {
      if (fillUrls.indexOf(objs.getAttribute('href')) > -1) {
        let pathObjs = objs.firstChild.firstChild.children[0].children;
        for (let i = 0; i < pathObjs.length; i++) {
          pathObjs[i].style.fill = 'none';
        }
      }
      if (strokeUrls.indexOf(objs.getAttribute('href')) > -1) {
        let pathObjs = objs.firstChild.firstChild.children[0].children;
        for (let i = 0; i < pathObjs.length; i++) {
          pathObjs[i].style.stroke = 'none';
        }
      }
    })
    // 有下级导航
    jumpMoreIconUrl.forEach(objs => {
      if (fillMoreUrls.indexOf(objs.getAttribute('href')) > -1) {
        if (Boolean(objs.firstChild.firstChild.children[0])) {
          let pathObjs = objs.firstChild.firstChild.children[0].children;
          for (let i = 0; i < pathObjs.length; i++) {
            pathObjs[i].style.fill = 'none';
          }
        }
      }
      if (strokeMoreUrls.indexOf(objs.getAttribute('href')) > -1) {
        if (Boolean(objs.firstChild.firstChild.children[0])) {
          let pathObjs = objs.firstChild.firstChild.children[0].children;
          for (let i = 0; i < pathObjs.length; i++) {
            pathObjs[i].style.stroke = 'none';
          }
        }
      }
    })

    // 默认展开二级导航栏处理
    // const urlPath = window.location.pathname;
    // const objUrls = ['/speedOpt/site-speedup', '/speedOpt/instant-page', '/speedOpt/PageSpeed', '/admin/PageSpeed/setting'];
    // let fatherIcon = document.querySelectorAll('.Polaris-Navigation__ItemInnerWrapper .Polaris-Navigation--subNavigationActive');
    // fatherIcon.forEach(tag => {
    //   if(tag.getAttribute('href').indexOf(objUrls[0]) > -1 && indexTag === 0 && tag.getAttribute('aria-expanded')) {
    //     if(objUrls.includes(urlPath)) {
    //       if(Boolean(tag.firstChild.firstChild.children[1])) {
    //         tag.firstChild.firstChild.children[1].style.fill = '#008060';
    //         let pathObjs = tag.firstChild.firstChild.children[1].children;
    //         for(let i = 0; i < pathObjs.length; i++) {
    //           pathObjs[i].style.fill = '#008060';
    //           pathObjs[i].style.stroke = 'none';
    //         }
    //       }
    //       indexTag += 1;
    //     } else {
    //       if(Boolean(tag.firstChild.firstChild.children[1])) {
    //         tag.firstChild.firstChild.children[1].style.fill = '#5c5f62';
    //         let pathObjs = tag.firstChild.firstChild.children[1].children;
    //         for(let i = 0; i < pathObjs.length; i++) {
    //           pathObjs[i].style.fill = '#5c5f62';
    //           pathObjs[i].style.stroke = 'none';
    //         }
    //         document.querySelectorAll('.Polaris-Navigation__ItemInnerWrapper--selected')[0].style.backgroundColor = 'unset';
    //         document.querySelectorAll('.Polaris-Navigation__Item--selected')[0].style.color = 'unset';
    //       }
    //     }
    //   }
    // })
  }

  // 获取活动改版弹窗数据
  getDiscountActData = async () => {
    store.subscribe(() => {
      const res = this.props.public.ActMealData;
      if (Boolean(this.props.public.Language) && res && Object.keys(res).length > 0) {
        if (res.plan_type === 0) {
          let _data = this.props.public.publicInit;
          // 没有活动
          this.setState({
            ActRversion: {},
            isHasActivityMeal: false,
            quotaAll: _data.meal_data,
            switchData: _data.head_data?.switch_data,
            // isNewUserIncentives: this.props.public.publicInit?.other_options?.is_new_user_incentives
          })
        } else {
          this.setState({
            ActRversion: res,
            isHasActivityMeal: true,
          })
          if (Boolean(res.expired_time)) {
            this.countdown(res.expired_time)
          }
        }
        this.setState({
          isActLoading: false
        })
      }
    })
  }

  // 关闭新手引导提示弹窗
  closeNewbieTipModal = () => {
    if (window.innerWidth < 1080) {
      document.getElementsByClassName('Polaris-Navigation__ListItem')[document.getElementsByClassName('Polaris-Navigation__ListItem').length - 1].setAttribute('id', '');
    } else {
      document.getElementById(5).style.boxShadow = 'unset';
    }
    this.setState({
      isHideNewbieTipModal: false,
    }, () => {
      // 删除点击监听
      setTimeout(() => {
        window.removeEventListener('click', this.closeNewbieTipModal, true);
      }, 100)
    })
  }

  // 获取公共数据
  getPublicAppData = async () => {
    const params = new URLSearchParams(window.location.search);
    if (getCookie("seoant_irclickid") && getCookie("seoant_irclickid").length > 1) {
      params.set('irclickid', getCookie("seoant_irclickid"));
    }
    const response = await reqGetHomeCommonData(params); // 新公共接口
    if (response.code === 301) {
      // 否则跳转安装
      window.location.href = response.jump_url;
    } else {
      if (response.code === 200) {
        const isShopify = window.shopify;

        // 判断是否跳转
        let switchData = response.data.head_data?.switch_data;
        let isGoGuide = typeof switchData === 'boolean' ? true : (Boolean(switchData?.newbie_guide_page) ? Boolean(Number(switchData?.newbie_guide_page?.st) === 0) : false);
        let isGoPricing = typeof switchData === 'boolean' ? false : (Boolean(switchData?.select_version) ? Boolean(Number(switchData?.select_version?.st) === 0) : false);

        const _store = store.getState().public;
        if (!window.opener && !Boolean(_store.shopifyLangState)) {
          // 获取授权数据 翻译shopify语言
          this.setShopifyLanguage();
        }

        // 判断是否进行引导
        if (isGoGuide) {
          utils.routeJump(this, "/guide");
          this.setState({
            pageName: "NewUserGuide",
            isShowShopifyNavMenu: false
          }, () => {
            this.props.getPublicDataRedux(response);
          })
        } else if (isGoPricing) {
          utils.routeJump(this, "/plan");
          this.setState({
            pageName: "pricing",
            isShowShopifyNavMenu: false
          }, () => {
            this.props.getPublicDataRedux(response);
          })
        } else {
          this.setState({
            isCanSetModal: true
          }, () => {
            this.props.getPublicDataRedux(response);
          })
        }

        // 获取顶部数据
        this.getHeaderInfo(response.data);
        // 获取活动数据
        this.getIndexInfoData(response.data);

        // 条件: 大于测试id 且 id为单数 且 内嵌模式
        let uid = response.data.shop_data.id;
        // const isShowInfo = ((Number(uid) <= 37055) || (Number(uid) > 37055 && (Number(uid) % 2) !== 0) || !isShopify);
        const isShowInfo = Boolean(!isShopify);
        this.props.setShowTopMenu(isShowInfo);

        this.setState({
          uid: uid,
          isDouble: uid % 2 === 0,
          isShowInfo: isShowInfo,
          isNewUserIncentives: response.data.other_options?.is_new_user_incentives,
          quotaAll: response.data.meal_data,
          switchData,
          trial_days: response.data.other_options?.trial_days,
          ppid: response.data.shop_data.pricing_plan_id,
          isShowExpertModal: Boolean(response.data.other_options.paid_confirm) && response.data.shop_data.pricing_plan_id === 10,// 是否展示专家服务的升级弹窗

          modalEmail: response.data.shop_data.email,
          modalDefaultEmail: response.data.shop_data.email,
          modalName: window.shopOwner,
        }, () => {
          if (isShopify) {
            Boolean(document.getElementById('SEOpage_content')) && (document.getElementById('SEOpage_content').style.paddingLeft = '');
            Boolean(document.getElementById('TabsPublic')) && (document.getElementById('TabsPublic').style.paddingLeft = '');
          } else {
            Boolean(document.getElementById('SEOpage_content')) && (document.getElementById('SEOpage_content').style.paddingLeft = '15rem');
            Boolean(document.getElementById('TabsPublic')) && (document.getElementById('TabsPublic').style.paddingLeft = '15rem');
          }

          // 埋点
          if (this.state.isNeedCio) {
            this.cioDataSet();
          }
          
          // 判断是否本地更新语言
          if(!window.shopify) {
            this.handleLanguageSet(response.data.shop_data?.language || 'en');
          }
        })
      }
    }
  }

  // 接收 主窗口
  handleDataFromMainWin = (ev) => {
    const _t = ev.data;
    if (_t.mode === "edit_page_modal") {
      store.dispatch(setWindowSendData(_t));
      if (!_t.shopifyLang) {
        // 更新shopify语言
        this.setShopifyLanguage();
      } else {
        // 更新本地语言
        this.handleLanguageSet(_t.language || 'en');
      }

      // 根据不同modal组件传参定义事件
      switch (_t.objs) {
        // case "amp":
        // break;
        case "onpageAi":
          if (_t._query) {
            this.setState({
              embedOnpageAIData: _t._query,
            })
          }
          break;
        case "onpageBlog":
          if (_t._query) {
            this.setState({
              embedOnpageBlogData: _t._query,
            })
          }
          break;
        default:
          break;
      }
    }
  }

  // 设置shopify语言
  setShopifyLanguage = () => {
    const params = new URLSearchParams(window.location.search);
    const shopifyLang = params.get("locale");
    if (shopifyLang) {
      // 获取授权数据 翻译shopify语言
      const ShopifyLangList = {
        "cs": "cs",
        "da": "da",
        "de": "ge",
        "en": "en",
        "es": "sp",
        "fr": "fr",
        "it": "it",
        "in": "in",
        "nl": "dut",
        "nb": "nb",
        "pl": "pl",
        "pt-BR": "pt_BR",
        "pt-PT": "pt",
        "fi": "fi",
        "sv": "sv",
        "tr": "tr",
        "th": "th",
        "ja": "ja",
        "zh-CN": "zh",
        "zh-TW": "zh_hant",
        "ko": "ko",
      }
      const lang = ShopifyLangList[shopifyLang] ? ShopifyLangList[shopifyLang] : 'en';
      store.dispatch(setShopifyLang(lang));
      store.dispatch(changeLanguageInfo(lang));
    } else {
      this.handleLanguageSet('en');
    }
  }

  // 设置更新语言
  handleLanguageSet = (lang = 'en') => {
    store.dispatch(setLangState(false)); // 重置语言状态
    store.dispatch(changeLanguageInfo(lang));
  }

  // 判断接口状态
  changeAppHomeStatus = () => {
    let res = this.props.public;
    if (Number(res.error.code) === 300) {
      this.toggleToast(res.error.msg, true);
    } else {
      if (!res.status) {
        setTimeout(() => {
          this.changeAppHomeStatus();
        }, 1000)
      }
    }
  }

  // 获取活动数据
  getIndexInfoData = (data) => {
    let res = data.campaign_data.activity_list;
    if (res && Boolean(res.id)) {
      // 有活动
      this.setState({
        activityMes: res,
        isHasActivity: true,
        actId: res.id,
        actName: res.name,
      }, () => {
        window.actId = res.id;
        window.actName = res.name;
      })
    }
  }

  componentWillUnmount() {
    // 清空提示弹窗
    const isShopify = window.shopify;
    isShopify?.toast?.hide?.();
    // 清除
    window.removeEventListener('message', this.handleDataFromMainWin);
    window.removeEventListener('message', this.handleDataFromChildWin);
    window.removeEventListener('resize', this.reSize);
    // indexTag = 0;
    this.setState = () => false;
  }

  reSize = () => {
    this.setState({
      wInnerWidth: window.innerWidth,
    }, () => {
      // 设置缓存宽度
      this.props.saveWindowWidth(window.innerWidth);
    })
    // 解决屏幕改变出现2个下拉框
    let basicHiddenTimer = setInterval(() => {
      let basicHidden = document.querySelector('.basicHidden')
      if (basicHidden) {
        basicHidden.setAttribute('style', 'display:none')
        clearInterval(basicHiddenTimer)
      }
    }, 1);
    let AdvancedHiddenTimer = setInterval(() => {
      let AdvancedHidden = document.querySelector('.AdvancedHidden')
      if (AdvancedHidden) {
        AdvancedHidden.setAttribute('style', 'display:none')
        clearInterval(AdvancedHiddenTimer)
      }
    }, 1);

    this.resetContentSite();
  }

  //给子组件清除倒计时方法
  clearExpirationString = (val) => {
    if (val === true) {
      this.setState({
        couponExpirationString: " "
      })
      cacheTimer.forEach(item => {
        clearInterval(item);
      })
      // clearInterval(cacheTimer);
    }
  }

  //用户是否评价
  getHeaderInfo = (data) => {
    let _store = data;
    //把service相关服务存储window里
    window.userServices = _store.service_data
    this.setState({
      showReview: _store.head_data.is_review,
      countNews: _store.head_data.notice_num,
      //等级
      level: _store.shop_data.level,
      shopify_level: Boolean(_store.shop_data) && _store.shop_data.plan_display_name,
      userServices: _store.service_data,
      modalEmail: Boolean(_store.shop_data) && _store.shop_data.email,
      modalDefaultEmail: Boolean(_store.shop_data) && _store.shop_data.email,
      isFirstShownoviceGuide: Boolean(_store.other_options) && _store.other_options.new_hand_guide,
      isFirstCloseConponModal: Boolean(_store.campaign_data) && _store.campaign_data.coupon_list.coupon_pop ? false : true,
      showCouponData: Boolean(_store.campaign_data) && _store.campaign_data.coupon_list !== undefined ? _store.campaign_data.coupon_list : false,
      showBlackFridayModal: Boolean(_store.campaign_data) && _store.campaign_data.campaign_modal.middle_status ? Number(_store.campaign_data.campaign_modal.middle_status) : -1,
      showBlackFridayBanner: Boolean(_store.campaign_data) && _store.campaign_data.campaign_modal.top_status ? Number(_store.campaign_data.campaign_modal.top_status) : -1,
    }, () => {
      if (this.state.wInnerWidth < 768) {
        if (this.state.isFirstShownoviceGuide) {
          this.setState({
            noviceGuideBackdropStatus: false,
            showHi: false,
          })
        }
      } else {
        if (this.state.isFirstShownoviceGuide) {
          this.setState({
            noviceGuideBackdropStatus: true,
            showHi: true,
          })
        }
      }
    });
    window.email = Boolean(_store.shop_data) && _store.shop_data.email;

    this.setState({
      modalName: window.shopOwner
    });
  }


  openModal = ($type, isCredits = false) => {
    this.setState({
      upgradeModalShow: $type === 1 ? 'pro' : 'pre',
      creditsShow: isCredits
    })
    // if ($type === 1) {
    //   this.setState({
    //     proPlanshow: true
    //   });
    // }
    // if ($type === 2) {
    //   this.setState({
    //     premiumPlanShow: true
    //   });
    // }
  };

  closeModal = ($type) => {
    if ($type === 1) {
      this.setState({
        proPlanshow: false
      });
    }

    if ($type === 2) {
      this.setState({
        premiumPlanShow: false
      });
    }
  };

  closeCleanModal = () => {
    this.setState({
      showClean: false
    });
  };

  //选择类型
  selectClenCode = (type) => {
    this.setState({
      has_selected: true
    });
    if (type === '404') {
      this.setState({
        selected_404: 'selected',
        selected_json: '',
        selected_all: '',
        showCleanPrompt: this.state.app_status === 0 || this.state.app_status === 3 ? false : true,
        showCleanPromptText: t("This operation will delete the SEOMasterBrokenLinkRedirect.liquid file, which cannot automatically monitor new 404 links, are you sure you want to delete it?")
      });
    } else if (type === 'json') {
      this.setState({
        selected_404: '',
        selected_json: 'selected',
        selected_all: '',
        showCleanPrompt: this.state.app_status === 0 || this.state.app_status === 2 ? false : true,
        showCleanPromptText: t("This operation will delete the file inserted to introduce theme: {% render 'structuredDataV2' %}{% render 'SEO-Master' %} and the inserted file: SEOMaster.liquid, your JSON-LD will be affected, it may affect the inclusion, are you sure you want to delete it?")
      });
    } else if (type === 'all') {
      this.setState({
        selected_404: '',
        selected_json: '',
        selected_all: 'selected',
        showCleanPrompt: this.state.app_status === 0 ? false : true,
        showCleanPromptText: t("This operation will delete all the files, your JSON-LD, broken link will be affected (except for the changes that have been synced to Shopify online and will not be deleted), are you sure you want to delete them?")
      });
    }
  };

  //点击打开弹窗
  openReviewModal = () => {
    this.setState({
      openReview: true
    })
  }

  //组件传来的关闭新手折扣弹窗的方法
  changeOpenStatus = (val) => {
    if (val === false) {
      this.setState({
        firstReqClose: true
      })
    }
    this.setState({
      openStatus: val
    })
  }

  // 传递modal状态
  closeBigSaleModalStatus = (data, types) => {
    if (types === 'modal') {
      // 广告
      this.props.changeActivityShowStatus('0', '1');
      this.setState({
        showBlackFridayBanner: 0,
        showBlackFridayModal: 1,
      })
    } else {
      // 版图
      this.props.changeActivityShowStatus('1', '1');
      this.setState({
        showBlackFridayBanner: 1,
        showBlackFridayModal: 1,
      })
    }
  }

  // 跳转活动详情页
  jumpAppActivityDetail = () => {
    // 事件埋点
    let params = { from: 1, action: 1, event: this.state.actName };
    reqAddActionEventLog(params);
    utils.routeJump(this, '/admin/app-activity/index', { actId: this.state.actId, actName: this.state.actName }, { email_jump: 'app_jump' })
  }

  // 设置支付弹窗提示
  changePayTipStatus = (val) => {
    this.props.setPayTipStatusData(val);
  }


  // 时分秒倒计时
  countdown = async (end_time) => {
    var cacheTimer = setInterval(() => {
      let date1 = new Date(); //开始时间
      let date2 = end_time * 1000; //开始时间
      let date3 = date2 - date1 //时间差的毫秒数
      if (date3 < 1000) {
        clearInterval(cacheTimer);
        this.setState({
          isHasActivityMeal: false,
          openActMealModal: false
        })
      } else {
        //计算出小时数
        let leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
        let hours = Math.floor(date3 / (3600 * 1000))

        //计算相差分钟数
        let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2 / (60 * 1000))
        //计算相差秒数
        let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
        let seconds = Math.round(leave3 / 1000)

        let exp_time = "";

        if (hours < 10) {
          exp_time += "0" + hours + ":"
        } else {
          exp_time += hours + ":"
        }
        if (minutes < 10) {
          exp_time += "0" + minutes + ":"
        } else {
          exp_time += minutes + ":"
        }
        if (seconds < 10) {
          exp_time += "0" + seconds
        } else if (seconds === 60) {
          exp_time += "00"
        } else {
          exp_time += seconds
        }
        this.setState({ act_expired_time: exp_time })
      }
    }, 1000)
    // 毫秒倒计时
    setTimeout(() => {
      setInterval(() => {
        let date1 = new Date(); //开始时间
        let date2 = end_time * 1000; //开始时间
        let date3 = date2 - date1 //时间差的毫秒数
        if (date3 < 0) {
          this.setState({ act_expired_mills_time: "00" })
        } else {
          //计算相差毫秒数
          let milli = date3 % (100)

          let exp_time = "";

          if (milli < 10) {
            exp_time += "0" + milli
          } else {
            exp_time += milli
          }
          this.setState({ act_expired_mills_time: exp_time })
        }
      }, 80)
    }, 1000)
  }

  // 打开弹窗
  openActMealModalAction = () => {
    this.setState({
      openActMealModal: true
    })
  }

  // 关闭弹窗
  changeActMealModal = () => {
    this.setState({
      openActMealModal: false,
    }, () => {
      if (window.giftEvent) {
        window.giftEvent.changeActMealModal();
      }
    })
  }

  // 打开任务
  openTaskBlock = () => {
    this.setState({
      isShowTask: true,
    })
  }

  // 关闭任务
  closeTaskBlock = () => {
    this.setState({
      isShowTask: false,
    })
  }

  // 设置外层图片额度
  setImageQuota = () => {
    this.setState({
      isAddImageQuota: true
    })
  }

  // 关闭价格套餐
  changeUpgradeState = () => {
    this.setState({
      upgradeModalShow: false,
    })
  }

  // 获取服务计划
  getServicePlan = () => {
    let { uid } = this.state;
    let _store = this.props.public;
    this.setState({
      isShowExpertModal: false,
    }, () => {
      if (_store.publicInit?.other_options?.paid_confirm === 1) {
        this.delApiCache(uid);
      }
      try {
        window.Willdesk.show();
        window.Willdesk.chat("Hello, I just placed an order for the Enterprise plan. Please send me the service plan.");
      } catch (e) {
        this.toggleToast(t("Try again later"), true);
      }
    })
  }

  // 清除缓存
  delApiCache = async (id) => {
    let params = {
      key: `seoant_paid_confirm_${id}`
    }
    const res = await reqDelCache(params);
    if (res.ack === 1) {
      // 更新公共数据
      this.props.setPayTipState(0);
    }
  }

  // 打开内嵌全屏模态框
  showEditPageModal = (url, modal, _state = null, _query = null) => {
    this.handleModalCustomizeState(true, url, modal, _state, _query); // 打开弹窗
  }

  // 弹窗状态
  handleModalCustomizeState = async (state = true, url = null, modal = "", _state = null, _query = null) => {
    const shopify = window.shopify;
    if (shopify && modal) {
      if (state) {
        const _store = this.props.public;
        window.history.replaceState(null, "", url);      // 只更新路由不跳转
        this.setState({
          isOpenModal: true,
          isFromPage: (modal === "OnpageBlog_Modal" && _query?.keyword) ? 'keywords' : 'onpage',
        }, async () => {
          await shopify.modal.show(modal);
          // 对象属性定义
          const objs = modal === "AMP_Customize_Modal" ? "amp" :
            modal === "OnpageAI_Modal" ? "onpageAi" :
              modal === "OnpageBlog_Modal" ? "onpageBlog" : "";
          this.sendBadgeDataToModal({ mode: "edit_page_modal", objs, shopifyLang: Boolean(_store.shopifyLangState), language: _store.Language, _state, _query }, modal);
        })
      } else {
        // 更新路由
        const routeArr = ['/settings', '/plan', '/on-page-seo/detail', '/on-page-seo/generate-blog']; // 需要携带参数
        if (routeArr.filter(r => url.indexOf(r) > -1).length > 0) {
          utils.routeJump(this, url, _state, _query);
        } else {
          utils.routeJump(this, url);
        }
        this.setState({
          isOpenModal: false,
        }, async () => {
          await shopify.modal.hide(modal);
        })
      }
    } else {
      this.toggleToast(t("Try again later"), true);
    }
  }

  // 操作数据
  handleModalCustomizeData = (type = "save", objs = "") => {
    const shopify = window.shopify;
    if (shopify) {
      this.sendBadgeDataToModal({ mode: type }, objs);
    }
  }

  // 传递给窗口 通信
  sendBadgeDataToModal = (data, objs) => {
    const objsIframe = document.getElementById(objs);
    if (objsIframe && objsIframe.contentWindow) {
      objsIframe.contentWindow.postMessage(data, window.location.origin);
    } else {
      // 保证通信完成
      setTimeout(() => {
        this.sendBadgeDataToModal(data, objs);
      }, 100)
    }
  }

  // 关闭提示弹层
  updCongraState = (state) => {
    this.setState({
      congraState: -1
    }, () => {
      // 更新新手引导状态
      let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data || []);
      if (data?.get_guide_coupon && data?.get_guide_coupon?.st !== 1) {
        data.get_guide_coupon = { "at": Math.floor(new Date().getTime() / 1000), "st": state };
        store.dispatch(setSaveSwitchData(data));
      }

      try {
        sessionStorage.setItem("isOperaCongrats", "close");
      } catch (e) { }
    })
  }

  // // 回调 home数据更新
  // callbackGetHome = () => {
  //   this.getPublicAppData();
  // }

  // 任务操作
  toggleTaskType = (type, _state) => {
    this.setState({
      [type]: Boolean(_state)
    })
  }
  
  //弹窗组件关闭 子组件传值到父组件
  ChildrenChange = (val) => {//这个val就是子组件传来的
    this.setState({
      openReview: val
    })
  }

  //弹窗组件提交评价成功 子组件传值到父组件 如果有值重新请求接口
  ChildrenReRequest = (val) => {
    //这个val就是子组件传来的
    // if (val) {
    //     this.getHeaderInfo();
    // }
    this.setState({
      showReview: false
    })
  }

  //提示弹窗
  toggleToast = (showToastText, showToastIserror, showState = true) => {
    // 判断提示方式
    const shopify = window.shopify;
    if (showToastText) {
      if (shopify) {
        shopify.toast.hide();
        let settings = {
          duration: 3000,
          isError: Boolean(showToastIserror)
        }
        if (showState) {
          shopify.toast.show(showToastText, settings);
        } else {
          shopify.toast.hide();
        }
      } else {
        this.setState({
          showToast: false
        }, () => {
          this.setState({
            showToast: showState,
            showToastText: showToastText || '',
            showToastIserror: showToastIserror || ''
          });
        });
      }
    }
  };

  render() {
    const {
      state: {
        pageName,
        isHideNewbieTipModal,
        adverInfo,
        adverloading,
        isShowTask,
        // isNewUserIncentives,
        switchData,
        quotaAll,
        isAddImageQuota,
        upgradeModalShow,
        level,
        // isActLoading,
        trial_days,
        creditsShow,
        isShowExpertModal,
        isShowShopifyNavMenu,
        isOpenModal,
        isCanSetModal,
        onpagePubilsh,
        onpagePubilshLoading,
        embedOnpageAIData,
        congraState,
        embedOnpageBlogData,
        isFromPage,
        isShowFeedback,
        isShowSharePlat,

        openReview,
        reviewContent,
        modalEmail,
        modalName,
        modalDefaultEmail,

      },
    } = this;

    // 内嵌模式 shopify
    const isShopify = window.shopify;

    // 提示
    const toastMarkup = this.state.showToast ? <ToastFunc content={t(this.state.showToastText)} onDismiss={this.state.showToast} error={this.state.showToastIserror} /> : null;

    // 页面组件
    let pageContent = "";
    // 缓存接口数据
    let _store = this.props.public;
    // 入口页面
    if (pageName === "SpeedOptimization") {
      // 速度页面集合
      pageContent = <SpeedOptimization />
    } else if (pageName === "SearchAppearance") {
      // 搜索页面集合
      pageContent = <SearchAppearance />
    } else if (pageName === "Backlinks") {
      // 外链页面集合
      pageContent = <Backlinks />
    } else if (pageName === "SeoAnalytics") {
      // seo分析集合
      pageContent = <SeoAnalytics show={(e) => { this.openModal(e) }} />
    } else if (pageName === "ReportData") {
      // 报告
      pageContent = <ReportData show={(e) => { this.openModal(e) }} toggleToast={this.toggleToast} />
    } else if (pageName === "KeywordsResearch") {
      // 关键词合并页面
      pageContent = <KeywordsResearch userServices={this.state.userServices} show={() => { this.openModal(2) }} toggleToast={this.toggleToast} />
    } else if (pageName === "dashboard") {
      //首页
      pageContent = <DashboardClass toggleTaskType={this.toggleTaskType} isAddImageQuota={isAddImageQuota} adverloading={adverloading} adverInfo={adverInfo} changePayTipStatus={this.changePayTipStatus} isResetData={this.state.isResetData} dashboardData={_store} openReviewModal={this.openReviewModal} isFirstShownoviceGuide={this.state.isFirstShownoviceGuide} callbackGetHome={this.getPublicAppData} toggleToast={this.toggleToast} />
    } else if (pageName === "recentImprove") {
      //最近改进
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <RecentImprove toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "website-check") {
      //SEO Checker 检测页面
      pageContent =
        <Suspense fallback={<SkeltonLoading />}>
          <WebsiteCheckClass userServices={this.state.userServices} show={() => { this.openModal(1) }} toggleToast={this.toggleToast} />
        </Suspense>
      // } else if (pageName === "seo-expert-services") {
      //分数检测服务页面
      // pageContent = <ServiceMarketClass clearExpirationString={this.clearExpirationString} show={(e) => { this.openModal(e) }} />
    } else if (pageName === "SiteSpeedup") {
      // 速度优化
      pageContent = <SiteSpeedup upgradeModalShow={upgradeModalShow} show={(e) => { this.openModal(e) }} toggleToast={this.toggleToast} />
    } else if (pageName === "html-sitemap") {
      //HTML Sitemap 页面
      pageContent = <HtmlSitemap toggleToast={this.toggleToast} />
    } else if (pageName === "Broken-link") {
      // BrokenLink 页面
      pageContent = <BrokenLinkPage userServices={this.state.userServices} show={(e) => { this.openModal(e) }} toggleToast={this.toggleToast} />
    } else if (pageName === "structured-data") {
      // Json LD 页面
      pageContent = <StructuredData show={() => { this.openModal(1) }} toggleToast={this.toggleToast} />
    } else if (pageName === "Bulk-edit") {
      //批量操作页面V2
      pageContent = <ManualBulkEdit userServices={this.state.userServices} show={() => { this.openModal(1) }} toggleToast={this.toggleToast} />
    } else if (pageName === 'BacklinkAudit') {
      //外链审查页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <BacklinkAudit show={() => { this.openModal(2) }} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === 'exchange-backlink') {
      //外链互换页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ExchangeBacklink toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "InstantPage") {
      // Instant Page
      pageContent = <InstantPage toggleToast={this.toggleToast} />
    } else if (pageName === "InstantIndex") {
      // Instant Index
      pageContent = <InstantIndex show={() => { this.openModal(1) }} toggleToast={this.toggleToast} />
    } else if (pageName === "ImageAltText") {
      // 图片alt
      pageContent = <ImageAltText toggleToast={this.toggleToast} />
    } else if (pageName === "ImageOptAltDetail") {
      // 图片alt 详情
      pageContent = <ImageOptAltDetail toggleToast={this.toggleToast} />
    } else if (pageName === "ImageOptimization") {
      //图片压缩页面
      pageContent = <ImageOptimization toggleToast={this.toggleToast} />
    } else if (pageName === "ImageOptimizationDetail") {
      //图片压缩详情
      pageContent = <ImageOptimizationDetail toggleToast={this.toggleToast} />
    } else if (pageName === "ImageOptimizationSettings") {
      //图片压缩设置页
      pageContent = <ImageOptimizationSettings toggleToast={this.toggleToast} />
    } else if (pageName === "on-page-seo") {
      //On page 操作页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <OnPageSEOIndexClass show={(e, v) => { this.openModal(e, v) }} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "on-page-seo-detail") {
      //On page 操作页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <OnPageSEODetail embedOnpageAIData={embedOnpageAIData} show={(e, v) => { this.openModal(e, v) }} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "CreateBlogContent") {
      // 创建博客内容
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <CreateBlogContent embedOnpageBlogData={embedOnpageBlogData} show={(e, v) => { this.openModal(e, v) }} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "local-business") {
      //Local Business
      pageContent = <LocalBusiness show={() => { this.openModal(1) }} toggleToast={this.toggleToast} />
    } else if (pageName === "Keywords-data") {
      // 关键词
      pageContent = <KeywordsData level={level} show={(e) => { this.openModal(e) }} toggleToast={this.toggleToast} showEditPageModal={this.showEditPageModal} />
    } else if (pageName === "Competitor-keywords-detail") {
      //竞品关键词分析页面
      pageContent = <CompetitorKeywordsDetail level={this.state.level} userServices={this.state.userServices} show={(e) => { this.openModal(e) }} toggleToast={this.toggleToast} />
    } else if (pageName === "KeywordsSearch") {
      // 关键词搜索
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <KeywordsSearch show={() => { this.openModal(2) }} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "KeywordsGap") {
      // 关键词对比
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <KeywordsGap show={() => { this.openModal(2) }} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "KeywordsMonitor") {
      // 关键词监听
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <KeywordsMonitor show={() => { this.openModal(2) }} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "KeywordsWebsite") {
      // 我的网站关键词
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <KeywordsWebsite show={(e) => { this.openModal(e) }} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "KeywordsList") {
      // 关键词列表
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <KeywordsList show={() => { this.openModal(2) }} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "google-search-console") {
      //google流量分析页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <GoogleSearchConsole show={(e) => { this.openModal(e) }} userServices={this.state.userServices} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "seo-ant-amp") {
      //AMP 页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ServiceAMPClass userServices={this.state.userServices} level={this.state.level} show={() => { this.openModal(2) }} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === "seo-ant-amp-custome") {
      //AMP 设置页面
      pageContent = <Suspense fallback={<SkeltonLoading />}>
        <ServiceAMPCustome userServices={this.state.userServices} level={this.state.level} isCanSetModal={isCanSetModal} show={() => { this.openModal(2) }} showEditPageModal={this.showEditPageModal} toggleToast={this.toggleToast} />
      </Suspense>
    } else if (pageName === 'canny') {
      //问答页面
      pageContent = <Canny toggleToast={this.toggleToast} />
    } else if (pageName === "integration") {
      //推荐应用页面
      pageContent = <Integration toggleToast={this.toggleToast} />
    } else if (pageName === "pricing") {
      //价格页面
      pageContent = <Pricing language={window.language} toggleToast={this.toggleToast} />
    } else if (pageName === "oldversion-pricing") {
      //旧版价格页面
      pageContent = <OldPricing language={window.language} toggleToast={this.toggleToast} />
    } else if (pageName === "Settings") {
      // 设置页面
      pageContent = <Settings language={window.language} toggleToast={this.toggleToast} />
    } else if (pageName === "NewUserGuide") {
      // 新手引导
      pageContent = <NewUserGuide toggleToast={this.toggleToast} />
    } else {
      pageContent = null;
    }

    // 专家服务升级
    const upgradeIcon = <svg t="1713756501801" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9496" width="20" height="20"><path d="M648.743382 404.237493c121.111302 123.798399 170.182811 274.361137 109.637824 336.270999l-2.473836 2.38853-2.921685 2.516488-3.369534 2.665771-3.83871 2.83638-4.265233 2.964337-4.713083 3.113621-5.182259 3.262903-5.608782 3.412187-9.255556 5.39552-6.739069 3.774732-10.96165 5.95-11.942653 6.269893-12.966309 6.611112-9.191578 4.585126-14.651077 7.144266-26.657709 12.667743-17.316847 8.061291-31.136204 14.139248-41.052871 18.169895-45.083517 19.513442-40.647674 17.274195-43.441401 18.191221-46.277783 19.108245-69.437999 28.32115-52.974198 21.326167-102.856103 40.796957a38.173839 38.173839 0 0 1-41.415416-8.914338l-37.83262-38.66434a40.263803 40.263803 0 0 1-8.743728-42.332442l26.998927-71.293375 37.875272-98.505565 23.629393-60.523662 25.911293-65.386027 24.162547-59.798572 19.300181-46.768284 15.098926-35.82796 14.181901-32.970254 10.705736-24.31183 10.129929-22.47778 7.22957-15.674733 9.106274-19.257529 6.461828-13.264875 6.141936-12.219894 5.822044-11.174911 7.250897-13.328855 3.412186-5.971326 4.84104-8.103944 3.028316-4.819713 2.921685-4.350539 2.751075-3.924014 2.623119-3.454839 2.452509-2.985664 2.345878-2.537813c60.566314-61.909862 207.823496-11.729392 328.934798 112.111659z" fill="#CF411C" p-id="9497"></path><path d="M634.945352 418.035523c-112.602161-115.097323-246.445184-161.993563-298.353074-115.012018l-2.55914 2.473835-1.663441 1.748746-1.962008 2.345878-2.217921 2.921685-2.452509 3.454839-2.665771 3.987993-2.772402 4.414517-4.649104 7.741398-3.220251 5.630108-7.080288 12.987636-5.67276 10.940324-6.035305 12.027958-6.376524 13.030288-9.042295 19.086919-7.144266 15.504123-10.065951 22.328497-10.620431 24.162547-14.139248 32.842297-15.034948 35.678677-19.257529 46.640327-24.098568 59.670615-25.889967 65.300723-23.58674 60.438357-37.83262 98.42026-26.998928 71.272049a20.537099 20.537099 0 0 0 2.72975 19.534769l1.706093 1.983334 37.811294 38.643014c4.798388 4.926345 11.686739 6.824373 18.127242 5.224911l2.409857-0.767742 102.749472-40.775631 52.888893-21.283515 69.395347-28.278497 46.171152-19.065593 43.356097-18.148568 40.519717-17.231543 44.934233-19.449464 40.882262-18.105916 30.986921-14.07527 17.167564-7.975986 26.465773-12.582439 14.501793-7.080287 9.063621-4.499821 12.753048-6.504481 11.708066-6.141936 10.705735-5.822044 6.483155-3.625448 8.95699-5.203585 5.331542-3.241577 4.819714-3.049642 4.350538-2.857706 3.817384-2.644445 3.305555-2.409857 2.72975-2.153943 2.175269-1.83405 2.025986-1.940681c50.543015-51.673302 4.947671-191.530305-109.637824-308.674939z" fill="#F66E2E" p-id="9498"></path><path d="M336.592278 303.023505c51.90789-46.981546 185.750913-0.085305 298.353074 115.012018 81.636567 83.470617 128.255567 178.457364 130.046965 244.867047l-1.10896 1.023656-2.175269 1.834051-2.72975 2.153943-3.305556 2.431183-3.83871 2.644444-4.329211 2.857707-4.84104 3.049642-5.331542 3.220251-8.95699 5.203584-6.461829 3.625449-10.705735 5.822043-11.729392 6.141936-12.731722 6.504481-9.063621 4.521148-14.501793 7.080287-26.444447 12.582439-17.188891 7.975986-30.98692 14.07527-40.882262 18.105916-44.934233 19.449464-40.519717 17.210217-43.356098 18.148568-46.171151 19.086919-69.374021 28.257171-52.888893 21.304841-102.792125 40.775631-69.864522 31.605379-9.810037-10.023298-1.684767-1.962008a20.515773 20.515773 0 0 1-3.497492-17.018281l0.767742-2.516488 26.998928-71.272049 37.83262-98.42026 23.58674-60.438357 25.889967-65.300723 24.098568-59.670615 19.257529-46.640327 15.034948-35.700003 14.139248-32.820971 10.620431-24.162547 10.065951-22.328497 7.144266-15.504123 9.042295-19.086919 6.376524-13.030288 6.035305-12.027958 5.67276-10.940324 7.080288-12.987636 3.198925-5.630108 4.649104-7.741398 2.793728-4.414517 2.665771-3.987993 2.452509-3.454839 2.217921-2.921685 1.962008-2.345878 1.642114-1.748746 2.55914-2.473835z" fill="#FD9816" p-id="9499"></path><path d="M391.933681 285.258808h-2.836381c-22.008604 0.426523-39.66667 6.419176-52.078499 17.380826l-2.985663 2.857706-1.663441 1.748746-1.962008 2.345878-2.217921 2.921685-2.452509 3.454839-2.665771 3.987993-2.772402 4.414517-4.649104 7.741398-3.220251 5.630108-7.080288 12.987636-5.67276 10.940324-6.035305 12.027958-6.376524 13.030288-9.042295 19.086919-7.144266 15.504123-10.065951 22.328497-10.620431 24.162547-14.608424 33.929932 1.535484 9.212904a1018.687012 1018.687012 0 0 0 144.143562 373.805052l7.720072 11.96398 8.359858-3.433513 43.356097-18.148568 10.129929-4.329212-2.985663-7.592115c-70.696243-181.48568-90.29499-380.181576-57.090149-572.436971l0.981004-5.544803zM161.675057 683.418343l-9.703406 24.525092-24.077242 61.696601 3.28423 9.490144a1013.35547 1013.35547 0 0 0 79.397319 170.737292l9.340861 15.696058 9.170252-3.625448 38.579035-15.568102L263.123633 938.351342A1056.519632 1056.519632 0 0 1 166.302835 701.119061l-4.649104-17.700718z" fill="#FFD217" p-id="9500"></path><path d="M319.808584 292.125834c60.566314-61.909862 207.823496-11.729392 328.934798 112.111659 121.111302 123.798399 170.182811 274.361137 109.637824 336.270999-60.566314 61.909862-207.823496 11.729392-328.934798-112.090333-121.132628-123.819725-170.204138-274.382463-109.637824-336.292325z" fill="#CF411C" p-id="9501"></path><path d="M634.945352 418.035523c-114.50019-117.05933-251.008984-163.5717-301.338738-112.090333-50.543015 51.651976-4.947671 191.508978 109.616498 308.653613 114.521516 117.080656 251.008984 163.5717 301.360064 112.111659 50.543015-51.673302 4.947671-191.530305-109.637824-308.674939z" fill="#B03414" p-id="9502"></path><path d="M590.203054 115.310584a9.68208 9.68208 0 0 1 12.369177 6.013979c33.482082 96.436927 15.35484 177.433708-36.297136 248.215256-5.886022 8.061291-12.006632 15.717385-18.596418 23.373479l-8.061291 9.106273-17.700718 18.980289a9.618101 9.618101 0 0 1-13.6914 0.55448 9.895341 9.895341 0 0 1-0.533154-13.862008l17.615414-18.91631 1.27957-1.407527c8.807707-9.810037 16.63441-19.321507 24.077243-29.494089 48.090506-65.897856 64.746243-140.326178 33.610038-230.045362a9.852689 9.852689 0 0 1 5.928675-12.51846z" fill="#17BA55" p-id="9503"></path><path d="M677.149836 535.905247c92.704847-69.54463 183.149121-92.982087 271.140885-44.187818 4.691757 2.601792 6.39785 8.573119 3.838711 13.328854a9.639427 9.639427 0 0 1-13.179572 3.881363c-79.823843-44.273122-162.953241-22.733694-250.241241 42.737638a626.776044 626.776044 0 0 0-35.038893 28.427781l-36.041222 32.053228-2.025985 1.706094a9.618101 9.618101 0 0 1-13.648747-1.428853 9.895341 9.895341 0 0 1 1.428853-13.819357l28.363802-25.250181a689.709562 689.709562 0 0 1 45.403409-37.448749z" fill="#FC5965" p-id="9504"></path><path d="M735.071705 284.448413a9.703406 9.703406 0 0 1 11.68674 7.272223c12.753048 54.381725-20.174554 105.671157-83.662553 156.17152-9.852689 7.826703-20.089249 15.376166-31.200182 23.074913l-19.406812 13.051614-19.577421 12.7957a9.639427 9.639427 0 0 1-13.435485-2.857706 9.895341 9.895341 0 0 1 1.27957-12.326525l1.642115-1.322222 30.219178-19.854661c14.07527-9.490144 26.615056-18.553765 38.493731-28.001258 58.092479-46.192477 87.224022-91.57456 76.774201-136.188901a9.810037 9.810037 0 0 1 7.186918-11.814697z" fill="#FFD217" p-id="9505"></path><path d="M273.232236 239.364897l-0.213262-3.540144a35.870613 35.870613 0 0 0-2.985663-10.876345 44.934234 44.934234 0 0 0-5.67276-9.148926 94.453593 94.453593 0 0 0-11.302869-11.836022l-5.096954-4.414517-16.293191-13.52079c-25.889967-21.710038-36.254484-37.064878-33.71667-56.57832 3.625448-28.171866 17.977959-41.628678 45.382083-42.716312a9.767384 9.767384 0 0 0 9.319535-10.193908 9.746058 9.746058 0 0 0-10.087277-9.426166c-36.915595 1.492832-59.009504 22.179214-63.850544 59.777246-3.497491 26.934949 8.615771 46.533696 36.105201 70.440329l21.880647 18.276525c5.736739 4.947671 9.68208 8.829033 12.433155 12.369177 1.471506 1.855377 2.537814 3.56147 3.220252 5.11828a16.058604 16.058604 0 0 1 1.364874 4.905018c0.895699 8.189248-4.371864 18.169894-15.418818 30.496419l-4.137277 4.39319-13.179571 13.328854-4.926344 5.267564a9.895341 9.895341 0 0 0 1.215591 13.819356c3.604122 3.049642 8.743728 2.985663 12.262546 0.149283l5.694087-5.907348 13.90466-14.053944c15.738711-16.570432 24.397135-30.858963 24.098569-46.128499z" fill="#CF411C" p-id="9506"></path><path d="M742.685147 823.829826l3.518817 0.255914c3.668101 0.405197 7.272223 1.407527 10.748388 3.006989 3.049642 1.407527 6.035305 3.326882 9.042295 5.715413 3.753405 2.985663 7.464158 6.67509 11.68674 11.452151l4.39319 5.139607 13.35018 16.485127c21.454124 26.209859 36.659681 36.659681 55.959862 34.121867 27.830648-3.689427 41.138176-18.19122 42.225811-45.936564a9.746058 9.746058 0 0 1 10.06595-9.404839c5.374194 0.213262 9.532797 4.777061 9.319535 10.193907-1.471506 37.342118-21.944626 59.691941-59.094808 64.618286-26.657709 3.497491-46.021868-8.743728-69.651261-36.55305l-18.063263-22.136561a91.851801 91.851801 0 0 0-12.219894-12.582439 25.356812 25.356812 0 0 0-5.054301-3.241577 15.610754 15.610754 0 0 0-4.84104-1.386201c-8.12527-0.895699-17.977959 4.435843-30.1552 15.610754l-4.371864 4.158603-13.179572 13.35018-3.924014 3.83871a35.081544 35.081544 0 0 1-1.27957 1.151613 9.618101 9.618101 0 0 1-13.648747-1.236917 9.895341 9.895341 0 0 1-0.149283-12.41183l5.843369-5.758065 13.883335-14.07527c16.399822-15.887994 30.496419-24.653049 45.595345-24.354482zM356.318982 1.748746a9.639427 9.639427 0 0 1 13.499464 2.473835c33.524734 48.900901 44.891581 117.848398 13.456811 218.166687a9.68208 9.68208 0 0 1-12.155915 6.39785 9.831363 9.831363 0 0 1-6.333872-12.326524c29.579393-94.410941 19.236203-157.045893-10.918997-201.063102a9.895341 9.895341 0 0 1 2.452509-13.648746zM709.821524 203.089087a19.620074 19.620074 0 0 1 19.364159 19.812009 19.620074 19.620074 0 0 1-19.364159 19.833335 19.620074 19.620074 0 0 1-19.406812-19.833335 19.620074 19.620074 0 0 1 19.406812-19.833335z" fill="#FD9816" p-id="9507"></path><path d="M477.217022 222.901096a19.620074 19.620074 0 0 1 19.385486 19.833335 19.620074 19.620074 0 0 1-19.406812 19.790683 19.620074 19.620074 0 0 1-19.36416-19.812009 19.620074 19.620074 0 0 1 19.385486-19.833335z" fill="#FC5965" p-id="9508"></path><path d="M787.34214 539.957219a19.620074 19.620074 0 0 1 19.385486 19.812009 19.620074 19.620074 0 0 1-19.385486 19.812009 19.620074 19.620074 0 0 1-19.385485-19.833336 19.620074 19.620074 0 0 1 19.406811-19.790682z" fill="#17BA55" p-id="9509"></path><path d="M903.633728 282.358449a19.620074 19.620074 0 0 1 19.406812 19.812009 19.620074 19.620074 0 0 1-19.406812 19.812009 19.620074 19.620074 0 0 1-19.364159-19.833335 19.620074 19.620074 0 0 1 19.364159-19.812009z" fill="#CF411C" p-id="9510"></path><path d="M453.736912 81.359327l-13.307528-12.561113 17.679392-4.051971c18.041937-4.158603 35.038892-17.807349 46.917567-37.662011l11.644088-19.449464 0.55448 22.776346c0.575807 23.288174 8.637098 43.782621 22.221866 56.620973l13.328854 12.539786-17.679392 4.051972c-18.041937 4.179929-35.060218 17.807349-46.917567 37.683337l-11.644087 19.449464-0.554481-22.797673c-0.575807-23.266848-8.637098-43.782621-22.243192-56.599646zM895.231218 576.16905l8.40251-16.421149 8.423836 16.421149c8.594445 16.741041 25.889967 30.005917 47.727961 36.595702l21.390146 6.440503-21.390146 6.461828c-21.837995 6.589786-39.133516 19.833335-47.727961 36.595702l-8.423836 16.399823-8.40251-16.399823c-8.594445-16.741041-25.889967-30.005917-47.727961-36.595702l-21.390145-6.461828 21.390145-6.440503c21.837995-6.611112 39.133516-19.854661 47.727961-36.595702z" fill="#FFE20D" p-id="9511"></path></svg>
    const expertSubplanModal = <Modal
      title={<span className="flex_layout" style={{ columnGap: 0 }}>
        {upgradeIcon}&nbsp;
        <span style={{ paddingTop: '5px' }}>{t("Subscription Successful!")}</span>
      </span>}
      open={isShowExpertModal}
      primaryAction={{
        content: t("Get Service Plan"),
        onAction: this.getServicePlan
      }}
      onClose={this.getServicePlan}
    >
      <Modal.Section>
        <p>{t("You have successfully subscribed to the Enterprise plan!")}</p>
        <p>{t("Our service plan has been sent to your email.")}</p>
        <p>{t("You can also click the button below to view the detailed service plan immediately.")}</p>
      </Modal.Section>
    </Modal>

    const newUserDiscountIcon = this.state.couponExpirationString !== " " && this.state.close === undefined &&
      (window.location.pathname !== '/dashboard' && window.location.pathname !== '/plan' && !window.location.pathname.includes('/admin/seo-expert-services')) ? <div className='emphasize' onClick={() => this.setState({ openStatus: true })}>
      <span className="time">{this.state.couponExpirationString}</span>
      <div className="in">
        <Icon source={BehaviorMajor} />
      </div>
      <svg t="1648014053003" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1775" width="4rem" height="4rem"><path d="M98.56 256.512m102.4 0l622.08 0q102.4 0 102.4 102.4l0 524.288q0 102.4-102.4 102.4l-622.08 0q-102.4 0-102.4-102.4l0-524.288q0-102.4 102.4-102.4Z" fill="#F6DAF7" p-id="1776"></path><path d="M98.56 280.832m102.4 0l622.08 0q102.4 0 102.4 102.4l0 427.264q0 102.4-102.4 102.4l-622.08 0q-102.4 0-102.4-102.4l0-427.264q0-102.4 102.4-102.4Z" fill="#F9E8F9" p-id="1777"></path><path d="M415.669592 175.023881m48.112263-17.511431l315.135317-114.699876q48.112262-17.511431 65.623694 30.600831l64.704738 177.774809q17.511431 48.112262-30.600831 65.623694l-315.135317 114.699875q-48.112262 17.511431-65.623693-30.600831l-64.704739-177.774809q-17.511431-48.112262 30.600831-65.623693Z" fill="#BE92F1" p-id="1778"></path><path d="M97.092709 298.04071m17.503034-48.115318l64.67371-177.786099q17.503034-48.115318 65.618352-30.612284l315.155331 114.644872q48.115318 17.503034 30.612284 65.618352l-64.67371 177.786099q-17.503034 48.115318-65.618352 30.612284l-315.155331-114.644872q-48.115318-17.503034-30.612284-65.618352Z" fill="#BE92F1" p-id="1779"></path><path d="M633.6 281.6h-243.2V163.072a76.8 76.8 0 0 1 76.8-76.8h89.6a76.8 76.8 0 0 1 76.8 76.8zM414.72 377.856h194.56v534.784h-194.56z" fill="#CBB0F7" p-id="1780"></path><path d="M414.72 912.64h194.56v72.96h-194.56z" fill="#BE92F1" p-id="1781"></path><path d="M98.56 450.816h826.88v48.64H98.56z" fill="#F6DAF7" p-id="1782"></path><path d="M414.72 450.816h194.56v48.64h-194.56z" fill="#BE92F1" p-id="1783"></path><path d="M25.6 232.192m51.2 0l870.4 0q51.2 0 51.2 51.2l0 116.224q0 51.2-51.2 51.2l-870.4 0q-51.2 0-51.2-51.2l0-116.224q0-51.2 51.2-51.2Z" fill="#F0A0F2" p-id="1784"></path><path d="M174.08 300.032c-34.816-2.048-42.24-25.6-21.248-29.44 37.888-7.168 217.6 0 238.848 8.192 4.608 2.048-11.008 7.936-41.472 10.496-68.608 6.4-154.624 12.288-176.128 10.752z" fill="#FFFFFF" p-id="1785"></path><path d="M105.984 283.904m-16.384 0a16.384 16.384 0 1 0 32.768 0 16.384 16.384 0 1 0-32.768 0Z" fill="#FFFFFF" p-id="1786"></path></svg>
    </div> : null
    const couponModal =
      <EventInformation
        showType={this.state.showType}
        couponData={this.state.showCouponData}
        openStatus={this.state.openStatus}
        isFirstCloseConponModal={this.state.isFirstCloseConponModal}
        firstReqClose={this.state.firstReqClose}
        isFirstShownoviceGuide={this.state.isFirstShownoviceGuide}
        noviceGuideIsDone={this.state.noviceGuideIsDone}
        level={this.state.level}
        showBlackFridayBanner={this.state.showBlackFridayBanner}
        showBlackFridayModal={this.state.showBlackFridayModal}
        activityMes={this.state.activityMes}
        isHasActivity={this.state.isHasActivity}
        actId={this.state.actId}
        actName={this.state.actName}
        ActRversion={this.state.ActRversion}
        isHasActivityMeal={this.state.isHasActivityMeal}
        act_expired_time={this.state.act_expired_time}
        act_expired_mills_time={this.state.act_expired_mills_time}
        openActMealModal={this.state.openActMealModal}
        isHideNewbieTipModal={isHideNewbieTipModal}
        changeOpenStatus={this.changeOpenStatus}
        closeBigSaleModalStatus={this.closeBigSaleModalStatus}
        changeActMealModal={this.changeActMealModal}
        trial_days={trial_days}
      />

    // 任务图标
    // const taskIcon = (isNewUserIncentives && !this.state.isHasActivityMeal && !isActLoading && window.location.pathname === '/dashboard') && <div className="task_gift" onClick={this.openTaskBlock}>
    //   <img src="/gift/stimulate.png" alt="stimulate" />
    // </div>

    // 任务奖励
    const taskBlock = <TaskReward
      quotaAll={quotaAll}
      switchData={switchData}
      isShowTask={isShowTask}
      isShowFeedback={isShowFeedback}
      isShowSharePlat={isShowSharePlat}
      closeTaskBlock={this.closeTaskBlock}
      setImageQuota={this.setImageQuota}
      toggleTaskType={this.toggleTaskType}
    />

    //newReview弹窗
    const newReview =
      <NewReviewModal
        open={openReview}
        changeData={this.ChildrenChange}
        content={reviewContent}
        reRequest={this.ChildrenReRequest}
        modalEmail={modalEmail}
        modalName={modalName}
        modalDefaultEmail={modalDefaultEmail}
      />


    return (
      Boolean(_store.status && _store.Language) ? <div id="SEOpage_content" style={{ paddingLeft: `${isShopify ? '' : window.isExpandedNav ? '15rem' : '3.8rem'}`, maxWidth: '100%' }} className={`${window.innerWidth <= 768 ? 'mobileNavPage' : ''}`}>
        {/* shopify - 内嵌模块 */}
        {
          (isShopify && !window.opener) ? <div className="ShopifyEmbedBlock">
            {/* 标题栏 */}
            {/* ... */}
            {/* 侧边导航栏 */}
            {
              isShowShopifyNavMenu && <NavMenuList />
            }
            {/* 模态框 */}
            <ModalAMPCustomize handleModalCustomizeState={this.handleModalCustomizeState} handleModalCustomizeData={this.handleModalCustomizeData} />
            <ModalOnpageAI
              onpagePubilsh={onpagePubilsh}
              onpagePubilshLoading={onpagePubilshLoading}
              handleModalCustomizeState={this.handleModalCustomizeState}
              handleModalCustomizeData={this.handleModalCustomizeData}
            />
            <ModalOnpageBlog isFromPage={isFromPage} handleModalCustomizeState={this.handleModalCustomizeState} handleModalCustomizeData={this.handleModalCustomizeData} />
          </div> : null
        }
        {/* shopify - 内嵌模块 */}

        {
          isOpenModal ? null : <>
            {couponModal}
            {pageContent}
            {taskBlock}
            {/* {taskIcon} */}
            {toastMarkup}
            {newUserDiscountIcon}
            {expertSubplanModal}
            {newReview}
            {/* 新版价格套餐弹窗 */}
            <UpgradeModal level={level} upgradeModalShow={upgradeModalShow} creditsShow={creditsShow} toggleToast={this.toggleToast} changeUpgradeState={this.changeUpgradeState} />
            {/* 完成新手引导弹窗 */}
            <CongratsModal
              congraState={congraState}
              toggleToast={this.toggleToast}
              updCongraState={this.updCongraState}
            />
          </>
        }
      </div> : <SkeltonSpinnerLoading />
    );
  }
}


function getCookie(cookieName) {
  //获取所有的cookie "psw=1234we; rememberme=true; user=Annie"
  var totalCookie = document.cookie;
  //获取参数所在的位置
  var cookieStartAt = totalCookie.indexOf(cookieName + "=");
  //判断参数是否存在 不存在直接返回
  if (cookieStartAt === -1) {
    return;
  }
  //获取参数值的开始位置
  var valueStartAt = totalCookie.indexOf("=", cookieStartAt) + 1;
  //以;来获取参数值的结束位置
  var valueEndAt = totalCookie.indexOf(";", cookieStartAt);
  //如果没有;则是最后一位
  if (valueEndAt === -1) {
    valueEndAt = totalCookie.length;
  }
  //截取参数值的字符串
  var cookieValue = unescape(totalCookie.substring(valueStartAt, valueEndAt));
  return cookieValue;
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => ({
  // 调用派遣 异步请求公共数据
  getPublicDataRedux(res) {
    // dispatch(fetchPublicData());
    dispatch(setPublicData(res));
  },

  // 修改活动banner/轮播图状态
  changeActivityShowStatus(banner, modal) {
    dispatch(changeActShowStatus([banner, modal]));
  },

  // 设置首页数据初始状态
  setAppPublicInit() {
    dispatch(setAppPublicInit());
  },

  // 设置新手引导状态
  setGuideStatus() {
    dispatch(setGuideModalStatus());
  },

  // 设置宽度数据缓存
  saveWindowWidth(val) {
    dispatch(setWindowWidth(val));
  },

  // 设置滚动高度
  saveWindoScrollTop(height) {
    dispatch(setWindowScrollY(height))
  },

  // 设置支付弹窗提示状态
  setPayTipStatusData(val) {
    dispatch(setPayTipStatus(val))
  },

  // 设置改版活动数据
  setActMealData(data) {
    dispatch(setActMealResData(data))
  },

  // 设置顶部导航栏状态
  setShowTopMenu(data) {
    dispatch(setTopMenuState(data))
  },

  // 设置广告数据
  setAdminAdverData(data) {
    dispatch(setAllAdverData(data));
  },

  // 是否设置了滚动条
  setScrollHidden(val) {
    dispatch(setScrollHiddenState(val));
  },

  // 设置支付回调提示状态
  setPayTipState(data) {
    dispatch(savePayTip(data));
  },
})

FrameClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(FrameClass);

export default withRouter(FrameClass);